import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
}

export function getOpenPlatformToken() {
  return request<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}
